import * as tslib_1 from "tslib";
import { getAlpha3Code, getSupportedLanguages } from 'i18n-iso-countries';
export function toCountryCode(countryName) {
    var e_1, _a;
    try {
        for (var _b = tslib_1.__values(getSupportedLanguages()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var language = _c.value;
            var countryCode = getAlpha3Code(countryName, language);
            if (countryCode) {
                return countryCode;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
